import React from 'react';
import './Pages.css';

export default function TermsPage() {
  return (
    <div className="static-page fade-in">
      <div className="static-card card">
        <h1>Terms &amp; Conditions</h1>
        <p className="static-updated">Last updated: April 2026</p>

        <section className="static-section">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using the Crunchy platform ("Service"), you agree to be bound by these Terms &amp; Conditions. If you do not agree to these terms, you may not use the Service. We reserve the right to update these terms at any time; continued use of the Service after changes constitutes acceptance of the revised terms.
          </p>
        </section>

        <section className="static-section">
          <h2>2. Account Registration</h2>
          <p>
            To access certain features of the Service, you must create an account. You agree to provide accurate, complete, and current information during registration and to keep your account credentials secure. You are solely responsible for all activity that occurs under your account. You must be at least 13 years of age to create an account. If we have reason to believe you are under 13, we may terminate your account without notice.
          </p>
        </section>

        <section className="static-section">
          <h2>3. User Content</h2>
          <p>
            You retain ownership of the recipes, images, comments, and other content ("User Content") that you submit to Crunchy. By posting User Content, you grant Crunchy a non-exclusive, worldwide, royalty-free licence to use, display, reproduce, and distribute your User Content within the Service for the purpose of operating and improving the platform. You represent and warrant that you have the right to share all content you post and that it does not infringe any third-party intellectual property rights.
          </p>
        </section>

        <section className="static-section">
          <h2>4. Prohibited Conduct</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Post content that is unlawful, harmful, threatening, abusive, defamatory, or otherwise objectionable.</li>
            <li>Impersonate any person or entity, or misrepresent your affiliation with a person or entity.</li>
            <li>Upload malicious software, spam, or any content designed to disrupt the Service.</li>
            <li>Attempt to gain unauthorised access to other users' accounts or any part of the Service's infrastructure.</li>
            <li>Scrape, harvest, or collect data from the Service by automated means without prior written consent.</li>
            <li>Use the Service for any commercial purpose without our express permission.</li>
          </ul>
        </section>

        <section className="static-section">
          <h2>5. Intellectual Property</h2>
          <p>
            The Crunchy name, logo, design, and all underlying technology are the property of Crunchy and are protected by applicable intellectual property laws. You may not copy, modify, distribute, or create derivative works based on the Service without express written permission.
          </p>
        </section>

        <section className="static-section">
          <h2>6. Termination</h2>
          <p>
            We reserve the right to suspend or terminate your account at our discretion, including but not limited to cases where you violate these Terms. Upon termination, your right to access the Service ceases immediately. We may delete your User Content following account termination.
          </p>
        </section>

        <section className="static-section">
          <h2>7. Disclaimers</h2>
          <p>
            The Service is provided "as is" and "as available" without warranties of any kind, whether express or implied. Crunchy does not guarantee that recipes shared on the platform are safe for all dietary needs or free from allergens. Users should exercise their own judgement and consult medical professionals where appropriate. We are not liable for any adverse effects resulting from the preparation or consumption of recipes found on the platform.
          </p>
        </section>

        <section className="static-section">
          <h2>8. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by applicable law, Crunchy and its operators shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or related to your use of the Service.
          </p>
        </section>

        <section className="static-section">
          <h2>9. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of the jurisdiction in which the Service operator is based, without regard to conflict of law principles.
          </p>
        </section>

        <section className="static-section">
          <h2>10. Contact</h2>
          <p>
            For questions about these Terms, please contact us at{' '}
            <a href="mailto:support@crunchyrecipes.co.uk">support@crunchyrecipes.co.uk</a>.
          </p>
        </section>
      </div>
    </div>
  );
}
